export default __webpack_public_path__ + "static/media/sequence_t_right.6f06947f.png";